import { render } from "./StartVirtualMachine.vue?vue&type=template&id=1bdffba2&scoped=true"
import script from "./StartVirtualMachine.vue?vue&type=script&lang=js"
export * from "./StartVirtualMachine.vue?vue&type=script&lang=js"

import "./StartVirtualMachine.vue?vue&type=style&index=0&id=1bdffba2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdffba2"]])

export default __exports__